export const productCategories = [
  { value: '1', label: 'ΖΥΜΑΡΙΚΑ' },
  { value: '2', label: 'ΟΣΠΡΙΑ' },
  { value: '3', label: 'ΡΥΖΙ' },
  { value: '4', label: 'ΓΑΛΑΚΤΟΚΟΜΙΚΑ-ΕΙΔΗ ΨΥΓΕΙΟΥ' },
  { value: '5', label: 'ΚΡΕΑΣ-ΨΑΡΙΑ-ΘΑΛΣΣΙΝΑ' },
  { value: '6', label: 'ΑΛΛΑΝΤΙΚΑ' },
  { value: '7', label: 'ΤΥΡΙΑ' },
  { value: '8', label: 'ΔΗΜΗΤΡΙΑΚΑ' },
  { value: '9', label: 'ΞΗΡΟΙ ΚΑΡΠΟΙ - ΣΠΟΡΟΙ - SUPERFOODS' },
  { value: '10', label: 'ΣΝΑΚΣ' },
  { value: '11', label: 'ΦΡΟΥΤΑ' },
  { value: '12', label: 'ΛΑΧΑΝΚΙΑ' },
  { value: '13', label: 'ΑΡΤΟΣΚΕΥΑΣΜΑΤΑ' },
  { value: '14', label: 'ΣΥΜΠΛΗΡΩΜΑΤΑ' },
  { value: '15', label: 'ΑΛΕΙΜΜΑΤΑ-ΠΑΣΤΕΣ' },
  { value: '16', label: 'ΕΛΑΙΑ' }
];

export const productFilters = [
  {
    name: 'ΚΑΤΗΓΟΡΙΕΣ',
    column: 'code',
    values: productCategories
  }
];

export const products2 = [
  {
    name: 'Barilla Integrale Spaghetti/Penne rigate ΟΛΙΚΗΣ ΑΛΕΣΗΣ',
    by: '100γρ.',
    energy: 350,
    fat: 2.5,
    kor_fat: 0.5,
    cabs: 65.7,
    sugar: 3.5,
    edodomes: 8,
    protein: 13,
    salt: 0.013,
    code: '1'
  },
  {
    name: 'Mellisa ΣΠΑΓΓΕΤΙ/ΛΙΓΚΟΥΪΝΙ ΟΛΙΚΗΣ ΑΛΕΣΗΣ  33333',
    by: '100γρ.',
    energy: 350,
    fat: 2.5,
    kor_fat: 0.5,
    cabs: 65.7,
    sugar: 3.5,
    edodomes: 8,
    protein: 13,
    salt: 0.013,
    code: '1'
  },
  {
    name: 'Mellisa ΣΠΑΓΓΕΤΙ/ΛΙΓΚΟΥΪΝΙ sdf',
    by: '100γρ.',
    energy: 350,
    fat: 2.5,
    kor_fat: 0.5,
    cabs: 65.7,
    sugar: 3.5,
    edodomes: 8,
    protein: 13,
    salt: 0.013,
    code: '6'
  },
  {
    name: 'Mellisa 4',
    by: '100γρ.',
    energy: 350,
    fat: 2.5,
    kor_fat: 0.5,
    cabs: 65.7,
    sugar: 3.5,
    edodomes: 8,
    protein: 13,
    salt: 0.013,
    code: '4'
  }
];

export const products = [
  {
    name: 'Barilla Integrale Spaghetti/Penne rigate ΟΛΙΚΗΣ ΑΛΕΣΗΣ',
    by: '100γρ.',
    energy: 350,
    fat: 2.5,
    kor_fat: 0.5,
    cabs: 65.7,
    sugar: 3.5,
    edodomes: 8,
    protein: 13,
    salt: 0.013,
    code: 1
  },
  {
    name: 'Mellisa ΣΠΑΓΓΕΤΙ/ΛΙΓΚΟΥΪΝΙ ΟΛΙΚΗΣ ΑΛΕΣΗΣ',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 356,
    'Λιπαρά (γρ.)': 2.1,
    'Κορεσμένα (γρ.)': 0.4,
    'Υδατάνθρακες (γρ.)': 68,
    'Σάκχαρα (γρ.)': 2.6,
    'Εδώδιμες ίνες  (γρ.)': 7,
    'Πρωτεϊνη (γρ.)': 12.8,
    'Αλάτι (γρ.)': 0.15,
    'Κωδικός -Κατηγοριας': 1
  },
  {
    name: 'Mellisa ΣΠΑΓΓΕΤΙ/ΡΙΓΕ ΔΙΚΟΚΚΟ ΣΙΤΑΡΙ',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 358,
    'Λιπαρά (γρ.)': 2.7,
    'Κορεσμένα (γρ.)': 0.4,
    'Υδατάνθρακες (γρ.)': 67,
    'Σάκχαρα (γρ.)': 2.4,
    'Εδώδιμες ίνες  (γρ.)': 7.5,
    'Πρωτεϊνη (γρ.)': 12.6,
    'Αλάτι (γρ.)': 0.48,
    'Κωδικός -Κατηγοριας': 1
  },
  {
    name: 'Mellisa ΡΙΓΚΑΤΟΝΙ ΜΕ ΧΑΡΟΥΠΙ',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 349,
    'Λιπαρά (γρ.)': 1.3,
    'Κορεσμένα (γρ.)': 0.2,
    'Υδατάνθρακες (γρ.)': 67,
    'Σάκχαρα (γρ.)': 3.4,
    'Εδώδιμες ίνες  (γρ.)': 8.2,
    'Πρωτεϊνη (γρ.)': 13.3,
    'Αλάτι (γρ.)': 0.18,
    'Κωδικός -Κατηγοριας': 1
  },
  {
    name: 'Mellisa Σπαγγέτι Χωρίς γλουτένη',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 358,
    'Λιπαρά (γρ.)': 1.5,
    'Κορεσμένα (γρ.)': 0.7,
    'Υδατάνθρακες (γρ.)': 78.2,
    'Σάκχαρα (γρ.)': 0.2,
    'Εδώδιμες ίνες  (γρ.)': 1.5,
    'Πρωτεϊνη (γρ.)': 7.1,
    'Αλάτι (γρ.)': 0.02,
    'Κωδικός -Κατηγοριας': 1
  },
  {
    name: 'Mellisa Πέννες ριγέ high protein',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 359,
    'Λιπαρά (γρ.)': 2,
    'Κορεσμένα (γρ.)': 0.4,
    'Υδατάνθρακες (γρ.)': 65.6,
    'Σάκχαρα (γρ.)': 3.5,
    'Εδώδιμες ίνες  (γρ.)': 2.9,
    'Πρωτεϊνη (γρ.)': 18.1,
    'Αλάτι (γρ.)': 0.18,
    'Κωδικός -Κατηγοριας': 1
  },
  {
    name: 'MISKO Κριθαράκι /κοφτό/σπαγγέτι κ.λ.π ολικής άλεσης',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 347,
    'Λιπαρά (γρ.)': 2.7,
    'Κορεσμένα (γρ.)': 0.6,
    'Υδατάνθρακες (γρ.)': 64,
    'Σάκχαρα (γρ.)': 3,
    'Εδώδιμες ίνες  (γρ.)': 7.5,
    'Πρωτεϊνη (γρ.)': 13,
    'Αλάτι (γρ.)': 0.02,
    'Κωδικός -Κατηγοριας': 1
  },
  {
    name: 'MISKO Σπαγγέτι/Πέννες χωρί γλουτένη',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 354,
    'Λιπαρά (γρ.)': 2.3,
    'Κορεσμένα (γρ.)': 0.6,
    'Υδατάνθρακες (γρ.)': 75.1,
    'Σάκχαρα (γρ.)': 0.6,
    'Εδώδιμες ίνες  (γρ.)': 2.8,
    'Πρωτεϊνη (γρ.)': 6.8,
    'Αλάτι (γρ.)': 0.003,
    'Κωδικός -Κατηγοριας': 1
  },
  {
    name: 'Φακές ψιλές 3άλφα',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 304,
    'Λιπαρά (γρ.)': 1.8,
    'Κορεσμένα (γρ.)': 0.3,
    'Υδατάνθρακες (γρ.)': 34.3,
    'Σάκχαρα (γρ.)': 1.6,
    'Εδώδιμες ίνες  (γρ.)': 26.4,
    'Πρωτεϊνη (γρ.)': 24.5,
    'Αλάτι (γρ.)': 0.03,
    'Κωδικός -Κατηγοριας': 2
  },
  {
    name: 'Φακές ψιλές Agrino',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 324,
    'Λιπαρά (γρ.)': 1.5,
    'Κορεσμένα (γρ.)': 0.1,
    'Υδατάνθρακες (γρ.)': 40,
    'Σάκχαρα (γρ.)': 2.5,
    'Εδώδιμες ίνες  (γρ.)': 25,
    'Πρωτεϊνη (γρ.)': 25,
    'Αλάτι (γρ.)': 0.001,
    'Κωδικός -Κατηγοριας': 2
  },
  {
    name: 'Φακές χονδρές 3άλφα',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 335,
    'Λιπαρά (γρ.)': 1.5,
    'Κορεσμένα (γρ.)': 0.3,
    'Υδατάνθρακες (γρ.)': 51.3,
    'Σάκχαρα (γρ.)': 1.5,
    'Εδώδιμες ίνες  (γρ.)': 11.8,
    'Πρωτεϊνη (γρ.)': 23.1,
    'Αλάτι (γρ.)': 0.05,
    'Κωδικός -Κατηγοριας': 2
  },
  {
    name: 'Φακές χονδρές Agrino',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 324,
    'Λιπαρά (γρ.)': 1.5,
    'Κορεσμένα (γρ.)': 0.1,
    'Υδατάνθρακες (γρ.)': 40,
    'Σάκχαρα (γρ.)': 2.5,
    'Εδώδιμες ίνες  (γρ.)': 25,
    'Πρωτεϊνη (γρ.)': 25,
    'Αλάτι (γρ.)': 0.001,
    'Κωδικός -Κατηγοριας': 2
  },
  {
    name: 'Ρεβύθια χονδρά 3άλφα',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 357,
    'Λιπαρά (γρ.)': 5.6,
    'Κορεσμένα (γρ.)': 1.1,
    'Υδατάνθρακες (γρ.)': 49.4,
    'Σάκχαρα (γρ.)': 3.7,
    'Εδώδιμες ίνες  (γρ.)': 13.7,
    'Πρωτεϊνη (γρ.)': 20.3,
    'Αλάτι (γρ.)': 0.11,
    'Κωδικός -Κατηγοριας': 2
  },
  {
    name: 'Ρεβύθια χονδρά Agrino',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 340,
    'Λιπαρά (γρ.)': 5.5,
    'Κορεσμένα (γρ.)': 0.5,
    'Υδατάνθρακες (γρ.)': 40,
    'Σάκχαρα (γρ.)': 3,
    'Εδώδιμες ίνες  (γρ.)': 23,
    'Πρωτεϊνη (γρ.)': 21,
    'Αλάτι (γρ.)': 0.04,
    'Κωδικός -Κατηγοριας': 2
  },
  {
    name: 'Μαυρομάτικα 3 άλφα',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 323,
    'Λιπαρά (γρ.)': 2.2,
    'Κορεσμένα (γρ.)': 0.8,
    'Υδατάνθρακες (γρ.)': 46.6,
    'Σάκχαρα (γρ.)': 2.7,
    'Εδώδιμες ίνες  (γρ.)': 14.7,
    'Πρωτεϊνη (γρ.)': 22,
    'Αλάτι (γρ.)': 0.03,
    'Κωδικός -Κατηγοριας': 2
  },
  {
    name: 'Μαυρομάτικα Agrino',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 316,
    'Λιπαρά (γρ.)': 2,
    'Κορεσμένα (γρ.)': 0.2,
    'Υδατάνθρακες (γρ.)': 43,
    'Σάκχαρα (γρ.)': 3,
    'Εδώδιμες ίνες  (γρ.)': 17,
    'Πρωτεϊνη (γρ.)': 23,
    'Αλάτι (γρ.)': 0.001,
    'Κωδικός -Κατηγοριας': 2
  },
  {
    name: 'Γίγαντες 3άλφα',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 298,
    'Λιπαρά (γρ.)': 2.1,
    'Κορεσμένα (γρ.)': 0.3,
    'Υδατάνθρακες (γρ.)': 38,
    'Σάκχαρα (γρ.)': 3.8,
    'Εδώδιμες ίνες  (γρ.)': 22.8,
    'Πρωτεϊνη (γρ.)': 20.4,
    'Αλάτι (γρ.)': 0.05,
    'Κωδικός -Κατηγοριας': 2
  },
  {
    name: 'Γίγαντες Agrino',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 310,
    'Λιπαρά (γρ.)': 2.2,
    'Κορεσμένα (γρ.)': 0.2,
    'Υδατάνθρακες (γρ.)': 40,
    'Σάκχαρα (γρ.)': 4,
    'Εδώδιμες ίνες  (γρ.)': 23,
    'Πρωτεϊνη (γρ.)': 21,
    'Αλάτι (γρ.)': 0.001,
    'Κωδικός -Κατηγοριας': 2
  },
  {
    name: 'Φάβα 3άλφα',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 340,
    'Λιπαρά (γρ.)': 1.7,
    'Κορεσμένα (γρ.)': 0.3,
    'Υδατάνθρακες (γρ.)': 46.4,
    'Σάκχαρα (γρ.)': 0.9,
    'Εδώδιμες ίνες  (γρ.)': 11.6,
    'Πρωτεϊνη (γρ.)': 28.9,
    'Αλάτι (γρ.)': 0.01,
    'Κωδικός -Κατηγοριας': 2
  },
  {
    name: 'Φάβα Agrino',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 337,
    'Λιπαρά (γρ.)': 1.7,
    'Κορεσμένα (γρ.)': 0.2,
    'Υδατάνθρακες (γρ.)': 44,
    'Σάκχαρα (γρ.)': 3.3,
    'Εδώδιμες ίνες  (γρ.)': 13,
    'Πρωτεϊνη (γρ.)': 30,
    'Αλάτι (γρ.)': 0.005,
    'Κωδικός -Κατηγοριας': 2
  },
  {
    name: 'Ρύζι parboiled BALI μακρύκοκκο',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 346,
    'Λιπαρά (γρ.)': 1.2,
    'Κορεσμένα (γρ.)': 0.5,
    'Υδατάνθρακες (γρ.)': 76,
    'Σάκχαρα (γρ.)': 0.5,
    'Εδώδιμες ίνες  (γρ.)': 1.3,
    'Πρωτεϊνη (γρ.)': 7.5,
    'Αλάτι (γρ.)': 0.01,
    'Κωδικός -Κατηγοριας': 3
  },
  {
    name: 'Ρυζι basmati 3άλφα',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 358,
    'Λιπαρά (γρ.)': 1.1,
    'Κορεσμένα (γρ.)': 0.3,
    'Υδατάνθρακες (γρ.)': 78,
    'Σάκχαρα (γρ.)': 0,
    'Εδώδιμες ίνες  (γρ.)': 1.2,
    'Πρωτεϊνη (γρ.)': 8.4,
    'Αλάτι (γρ.)': 0.03,
    'Κωδικός -Κατηγοριας': 3
  },
  {
    name: 'Ρύζι καστανό 3άλφα',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 354,
    'Λιπαρά (γρ.)': 3.3,
    'Κορεσμένα (γρ.)': 0.7,
    'Υδατάνθρακες (γρ.)': 71,
    'Σάκχαρα (γρ.)': 0,
    'Εδώδιμες ίνες  (γρ.)': 4.5,
    'Πρωτεϊνη (γρ.)': 7.7,
    'Αλάτι (γρ.)': 0,
    'Κωδικός -Κατηγοριας': 3
  },
  {
    name: 'Ρύζι risotto 3άλφα',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 351,
    'Λιπαρά (γρ.)': 1.1,
    'Κορεσμένα (γρ.)': 0.3,
    'Υδατάνθρακες (γρ.)': 78.6,
    'Σάκχαρα (γρ.)': 0.2,
    'Εδώδιμες ίνες  (γρ.)': 1.2,
    'Πρωτεϊνη (γρ.)': 6,
    'Αλάτι (γρ.)': 0.2,
    'Κωδικός -Κατηγοριας': 3
  },
  {
    name: 'Ρύζι jasmine 3άλφα',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 357,
    'Λιπαρά (γρ.)': 1.3,
    'Κορεσμένα (γρ.)': 0.4,
    'Υδατάνθρακες (γρ.)': 78.4,
    'Σάκχαρα (γρ.)': 0.1,
    'Εδώδιμες ίνες  (γρ.)': 0.8,
    'Πρωτεϊνη (γρ.)': 7.4,
    'Αλάτι (γρ.)': 0.04,
    'Κωδικός -Κατηγοριας': 3
  },
  {
    name: 'Ρυζι basmati Agrino',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 357,
    'Λιπαρά (γρ.)': 2.2,
    'Κορεσμένα (γρ.)': 0.27,
    'Υδατάνθρακες (γρ.)': 75.3,
    'Σάκχαρα (γρ.)': 0.4,
    'Εδώδιμες ίνες  (γρ.)': 2.4,
    'Πρωτεϊνη (γρ.)': 7,
    'Αλάτι (γρ.)': 0.0025,
    'Κωδικός -Κατηγοριας': 3
  },
  {
    name: 'Ρύζι καστανό Agrino',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 358,
    'Λιπαρά (γρ.)': 2.7,
    'Κορεσμένα (γρ.)': 0.5,
    'Υδατάνθρακες (γρ.)': 73,
    'Σάκχαρα (γρ.)': 0.8,
    'Εδώδιμες ίνες  (γρ.)': 5,
    'Πρωτεϊνη (γρ.)': 7.8,
    'Αλάτι (γρ.)': 0.02,
    'Κωδικός -Κατηγοριας': 3
  },
  {
    name: 'Ρύζι risotto Agrino',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 348,
    'Λιπαρά (γρ.)': 1,
    'Κορεσμένα (γρ.)': 0.3,
    'Υδατάνθρακες (γρ.)': 77.3,
    'Σάκχαρα (γρ.)': 0.2,
    'Εδώδιμες ίνες  (γρ.)': 1,
    'Πρωτεϊνη (γρ.)': 6.9,
    'Αλάτι (γρ.)': 0,
    'Κωδικός -Κατηγοριας': 3
  },
  {
    name: 'Ρύζι jasmine Agrino',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 354,
    'Λιπαρά (γρ.)': 1.2,
    'Κορεσμένα (γρ.)': 0.2,
    'Υδατάνθρακες (γρ.)': 79,
    'Σάκχαρα (γρ.)': 0.4,
    'Εδώδιμες ίνες  (γρ.)': 0.8,
    'Πρωτεϊνη (γρ.)': 6.5,
    'Αλάτι (γρ.)': 0.0025,
    'Κωδικός -Κατηγοριας': 3
  },
  {
    name: 'Γάλα milk free lactose 1,5% ΔΕΛΤΑ',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 46,
    'Λιπαρά (γρ.)': 1.5,
    'Κορεσμένα (γρ.)': 0.9,
    'Υδατάνθρακες (γρ.)': 4.7,
    'Σάκχαρα (γρ.)': 4.7,
    'Εδώδιμες ίνες  (γρ.)': 0,
    'Πρωτεϊνη (γρ.)': 3.3,
    'Αλάτι (γρ.)': 0.12,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Ρόφημα Αμυγδάλου  sugarfree ΔΕΛΤΑ',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 31,
    'Λιπαρά (γρ.)': 1.7,
    'Κορεσμένα (γρ.)': 0.1,
    'Υδατάνθρακες (γρ.)': 3,
    'Σάκχαρα (γρ.)': 2,
    'Εδώδιμες ίνες  (γρ.)': 0.4,
    'Πρωτεϊνη (γρ.)': 0.7,
    'Αλάτι (γρ.)': 0.1,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Ρόφημα Καρύδας  sugarfree ΔΕΛΤΑ',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 35,
    'Λιπαρά (γρ.)': 1.5,
    'Κορεσμένα (γρ.)': 1,
    'Υδατάνθρακες (γρ.)': 5,
    'Σάκχαρα (γρ.)': 2.7,
    'Εδώδιμες ίνες  (γρ.)': 0.2,
    'Πρωτεϊνη (γρ.)': 0.2,
    'Αλάτι (γρ.)': 0.1,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Ρόφημα Βρώμης&3 super σπόροι sugarfree ΔΕΛΤΑ',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 20,
    'Λιπαρά (γρ.)': 0.8,
    'Κορεσμένα (γρ.)': 0.1,
    'Υδατάνθρακες (γρ.)': 2.7,
    'Σάκχαρα (γρ.)': 1.6,
    'Εδώδιμες ίνες  (γρ.)': 0.2,
    'Πρωτεϊνη (γρ.)': 0.3,
    'Αλάτι (γρ.)': 0.1,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Ρόφημα Αμυγδάλου  protein ΔΕΛΤΑ',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 54,
    'Λιπαρά (γρ.)': 2,
    'Κορεσμένα (γρ.)': 0.2,
    'Υδατάνθρακες (γρ.)': 5.2,
    'Σάκχαρα (γρ.)': 4,
    'Εδώδιμες ίνες  (γρ.)': 1.3,
    'Πρωτεϊνη (γρ.)': 3.2,
    'Αλάτι (γρ.)': 0.11,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Ρόφημα Αμυγδάλου με κακάο ΔΕΛΤΑ',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 49,
    'Λιπαρά (γρ.)': 1.4,
    'Κορεσμένα (γρ.)': 0.2,
    'Υδατάνθρακες (γρ.)': 8.1,
    'Σάκχαρα (γρ.)': 6.5,
    'Εδώδιμες ίνες  (γρ.)': 0.4,
    'Πρωτεϊνη (γρ.)': 0.7,
    'Αλάτι (γρ.)': 0.15,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Ρόφημα Φουντούκι Dark choco sugar free ΔΕΛΤΑ',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 77,
    'Λιπαρά (γρ.)': 2.5,
    'Κορεσμένα (γρ.)': 0.4,
    'Υδατάνθρακες (γρ.)': 12.3,
    'Σάκχαρα (γρ.)': 4.8,
    'Εδώδιμες ίνες  (γρ.)': 0.5,
    'Πρωτεϊνη (γρ.)': 1,
    'Αλάτι (γρ.)': 0.2,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Γάλα  1,5% free lactose ΟΛΥΜΠΟΣ',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 44,
    'Λιπαρά (γρ.)': 1.5,
    'Κορεσμένα (γρ.)': 0.8,
    'Υδατάνθρακες (γρ.)': 4.4,
    'Σάκχαρα (γρ.)': 4.3,
    'Εδώδιμες ίνες  (γρ.)': 0,
    'Πρωτεϊνη (γρ.)': 3.3,
    'Αλάτι (γρ.)': 0.1,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Γάλα Κατσικίσιο 3,7% ΟΛΥΜΠΟΣ',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 67,
    'Λιπαρά (γρ.)': 3.7,
    'Κορεσμένα (γρ.)': 2.5,
    'Υδατάνθρακες (γρ.)': 4.6,
    'Σάκχαρα (γρ.)': 4.5,
    'Εδώδιμες ίνες  (γρ.)': 0,
    'Πρωτεϊνη (γρ.)': 3.7,
    'Αλάτι (γρ.)': 0.08,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Γάλα Κατσικίσιο  1,7% ΟΛΥΜΠΟΣ',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 50,
    'Λιπαρά (γρ.)': 1.7,
    'Κορεσμένα (γρ.)': 1.2,
    'Υδατάνθρακες (γρ.)': 4.8,
    'Σάκχαρα (γρ.)': 4.4,
    'Εδώδιμες ίνες  (γρ.)': 0,
    'Πρωτεϊνη (γρ.)': 3.8,
    'Αλάτι (γρ.)': 0.08,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Γάλα Κατσικίσιο  1,5% free lactose ΟΛΥΜΠΟΣ',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 45,
    'Λιπαρά (γρ.)': 1.5,
    'Κορεσμένα (γρ.)': 0.9,
    'Υδατάνθρακες (γρ.)': 4.7,
    'Σάκχαρα (γρ.)': 4.4,
    'Εδώδιμες ίνες  (γρ.)': 0,
    'Πρωτεϊνη (γρ.)': 3.6,
    'Αλάτι (γρ.)': 0.08,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Ρόφημα Φουντουκιού με κακάο ΟΛΥΜΠΟΣ',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 52,
    'Λιπαρά (γρ.)': 1.9,
    'Κορεσμένα (γρ.)': 0.3,
    'Υδατάνθρακες (γρ.)': 7.4,
    'Σάκχαρα (γρ.)': 7.4,
    'Εδώδιμες ίνες  (γρ.)': 1.6,
    'Πρωτεϊνη (γρ.)': 0.4,
    'Αλάτι (γρ.)': 0.1,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Ρόφημα Βρώμης καραμέλα ΟΛΥΜΠΟΣ',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 65,
    'Λιπαρά (γρ.)': 2.5,
    'Κορεσμένα (γρ.)': 0.4,
    'Υδατάνθρακες (γρ.)': 9.1,
    'Σάκχαρα (γρ.)': 7.5,
    'Εδώδιμες ίνες  (γρ.)': 2,
    'Πρωτεϊνη (γρ.)': 0.5,
    'Αλάτι (γρ.)': 0.19,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Ρόφημα Φυστίκι sugar free ΟΛΥΜΠΟΣ',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 24,
    'Λιπαρά (γρ.)': 1.7,
    'Κορεσμένα (γρ.)': 0.2,
    'Υδατάνθρακες (γρ.)': 0.5,
    'Σάκχαρα (γρ.)': 0.5,
    'Εδώδιμες ίνες  (γρ.)': 1.8,
    'Πρωτεϊνη (γρ.)': 0.7,
    'Αλάτι (γρ.)': 0.1,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Ρόφημα Βρώμης Dark chocolate ΟΛΥΜΠΟΣ',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 62,
    'Λιπαρά (γρ.)': 1.5,
    'Κορεσμένα (γρ.)': 0.3,
    'Υδατάνθρακες (γρ.)': 10.3,
    'Σάκχαρα (γρ.)': 8.3,
    'Εδώδιμες ίνες  (γρ.)': 1.9,
    'Πρωτεϊνη (γρ.)': 0.9,
    'Αλάτι (γρ.)': 0.11,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Ρόφημα Βρώμης sugarfree ΟΛΥΜΠΟΣ',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 54,
    'Λιπαρά (γρ.)': 1.5,
    'Κορεσμένα (γρ.)': 0.3,
    'Υδατάνθρακες (γρ.)': 8,
    'Σάκχαρα (γρ.)': 4.9,
    'Εδώδιμες ίνες  (γρ.)': 1.7,
    'Πρωτεϊνη (γρ.)': 1.2,
    'Αλάτι (γρ.)': 0.11,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Ρόφημα Βρώμης protein ΟΛΥΜΠΟΣ',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 64,
    'Λιπαρά (γρ.)': 1.5,
    'Κορεσμένα (γρ.)': 0.2,
    'Υδατάνθρακες (γρ.)': 8.4,
    'Σάκχαρα (γρ.)': 6.2,
    'Εδώδιμες ίνες  (γρ.)': 2,
    'Πρωτεϊνη (γρ.)': 3.2,
    'Αλάτι (γρ.)': 0.11,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Ρόφημα Αμυγδάλου με κακάο protein ΟΛΥΜΠΟΣ',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 63,
    'Λιπαρά (γρ.)': 1.9,
    'Κορεσμένα (γρ.)': 0.3,
    'Υδατάνθρακες (γρ.)': 7.2,
    'Σάκχαρα (γρ.)': 7.2,
    'Εδώδιμες ίνες  (γρ.)': 1.9,
    'Πρωτεϊνη (γρ.)': 3.2,
    'Αλάτι (γρ.)': 0.1,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Ρόφημα Αμυγδάλου sugarfree ΟΛΥΜΠΟΣ',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 24,
    'Λιπαρά (γρ.)': 1.7,
    'Κορεσμένα (γρ.)': 0.1,
    'Υδατάνθρακες (γρ.)': 0.5,
    'Σάκχαρα (γρ.)': 0.5,
    'Εδώδιμες ίνες  (γρ.)': 1.8,
    'Πρωτεϊνη (γρ.)': 0.7,
    'Αλάτι (γρ.)': 0.1,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Ρόφημα Βρώμης βανίλια ΟΛΥΜΠΟΣ',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 62,
    'Λιπαρά (γρ.)': 1.4,
    'Κορεσμένα (γρ.)': 0.2,
    'Υδατάνθρακες (γρ.)': 10.5,
    'Σάκχαρα (γρ.)': 8,
    'Εδώδιμες ίνες  (γρ.)': 1.9,
    'Πρωτεϊνη (γρ.)': 0.8,
    'Αλάτι (γρ.)': 0.1,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Ρόφημα Αμυγδάλου sugarfree Alpro',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 13,
    'Λιπαρά (γρ.)': 1.1,
    'Κορεσμένα (γρ.)': 0.1,
    'Υδατάνθρακες (γρ.)': 0,
    'Σάκχαρα (γρ.)': 0,
    'Εδώδιμες ίνες  (γρ.)': 0,
    'Πρωτεϊνη (γρ.)': 0.4,
    'Αλάτι (γρ.)': 0.14,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Ρόφημα Βρώμης sugarfree Alpro',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 40,
    'Λιπαρά (γρ.)': 1.5,
    'Κορεσμένα (γρ.)': 0.2,
    'Υδατάνθρακες (γρ.)': 5.8,
    'Σάκχαρα (γρ.)': 0,
    'Εδώδιμες ίνες  (γρ.)': 1.2,
    'Πρωτεϊνη (γρ.)': 0.2,
    'Αλάτι (γρ.)': 0.11,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Ρόφημα Καρύδας sugarfree Alpro',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 14,
    'Λιπαρά (γρ.)': 1.2,
    'Κορεσμένα (γρ.)': 1.1,
    'Υδατάνθρακες (γρ.)': 0.4,
    'Σάκχαρα (γρ.)': 0,
    'Εδώδιμες ίνες  (γρ.)': 0,
    'Πρωτεϊνη (γρ.)': 0.1,
    'Αλάτι (γρ.)': 0.07,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Ρόφημα Σιόγιας sugarfree Alpro',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 33,
    'Λιπαρά (γρ.)': 1.8,
    'Κορεσμένα (γρ.)': 0.3,
    'Υδατάνθρακες (γρ.)': 0,
    'Σάκχαρα (γρ.)': 0,
    'Εδώδιμες ίνες  (γρ.)': 0.6,
    'Πρωτεϊνη (γρ.)': 3.3,
    'Αλάτι (γρ.)': 0.09,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Ρόφημα Σιόγιας dark choco Protein Alpro',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 69,
    'Λιπαρά (γρ.)': 2.8,
    'Κορεσμένα (γρ.)': 0.6,
    'Υδατάνθρακες (γρ.)': 5.3,
    'Σάκχαρα (γρ.)': 5,
    'Εδώδιμες ίνες  (γρ.)': 1.3,
    'Πρωτεϊνη (γρ.)': 5,
    'Αλάτι (γρ.)': 0.16,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Ρόφημα Protein 50% less sugar Alra (choco)',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 47,
    'Λιπαρά (γρ.)': 0.6,
    'Κορεσμένα (γρ.)': 0.4,
    'Υδατάνθρακες (γρ.)': 4.8,
    'Σάκχαρα (γρ.)': 4.6,
    'Εδώδιμες ίνες  (γρ.)': 0,
    'Πρωτεϊνη (γρ.)': 5.5,
    'Αλάτι (γρ.)': 0.17,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Ρόφημα Protein 50% less sugar Alra (φράουλα)',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 46,
    'Λιπαρά (γρ.)': 0.7,
    'Κορεσμένα (γρ.)': 0.4,
    'Υδατάνθρακες (γρ.)': 4.6,
    'Σάκχαρα (γρ.)': 4.6,
    'Εδώδιμες ίνες  (γρ.)': 0,
    'Πρωτεϊνη (γρ.)': 5.4,
    'Αλάτι (γρ.)': 0.11,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Κεφίρ 1,5% ΜΕΒΓΑΛ',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 41,
    'Λιπαρά (γρ.)': 1.5,
    'Κορεσμένα (γρ.)': 0.9,
    'Υδατάνθρακες (γρ.)': 3.6,
    'Σάκχαρα (γρ.)': 3.6,
    'Εδώδιμες ίνες  (γρ.)': 0,
    'Πρωτεϊνη (γρ.)': 3.3,
    'Αλάτι (γρ.)': 0.11,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Κεφίρ 1,5% (Φράουλα) ΜΕΒΓΑΛ',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 48,
    'Λιπαρά (γρ.)': 1.3,
    'Κορεσμένα (γρ.)': 0.9,
    'Υδατάνθρακες (γρ.)': 6,
    'Σάκχαρα (γρ.)': 6,
    'Εδώδιμες ίνες  (γρ.)': 0,
    'Πρωτεϊνη (γρ.)': 3.1,
    'Αλάτι (γρ.)': 0.11,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Κεφίρ 1,5% (Ροδάκινο) ΜΕΒΓΑΛ',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 48,
    'Λιπαρά (γρ.)': 1.3,
    'Κορεσμένα (γρ.)': 0.9,
    'Υδατάνθρακες (γρ.)': 6,
    'Σάκχαρα (γρ.)': 6,
    'Εδώδιμες ίνες  (γρ.)': 0,
    'Πρωτεϊνη (γρ.)': 3.1,
    'Αλάτι (γρ.)': 0.11,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Ρόφημα γάλακτος ΜΕΒΓΑΛ high protein (choco)',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 65,
    'Λιπαρά (γρ.)': 0.3,
    'Κορεσμένα (γρ.)': 0.2,
    'Υδατάνθρακες (γρ.)': 5.5,
    'Σάκχαρα (γρ.)': 5.4,
    'Εδώδιμες ίνες  (γρ.)': 0,
    'Πρωτεϊνη (γρ.)': 10,
    'Αλάτι (γρ.)': 0.12,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Ρόφημα γάλακτος ΜΕΒΓΑΛ high protein (Vanilia)',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 64,
    'Λιπαρά (γρ.)': 0.2,
    'Κορεσμένα (γρ.)': 0.1,
    'Υδατάνθρακες (γρ.)': 5.7,
    'Σάκχαρα (γρ.)': 5.6,
    'Εδώδιμες ίνες  (γρ.)': 0,
    'Πρωτεϊνη (γρ.)': 10,
    'Αλάτι (γρ.)': 0.12,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Γάλα 1,5% free lactose ΜΕΒΓΑΛ',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 47,
    'Λιπαρά (γρ.)': 1.5,
    'Κορεσμένα (γρ.)': 1,
    'Υδατάνθρακες (γρ.)': 4.9,
    'Σάκχαρα (γρ.)': 4.9,
    'Εδώδιμες ίνες  (γρ.)': 0,
    'Πρωτεϊνη (γρ.)': 3.4,
    'Αλάτι (γρ.)': 0.1,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Γάλα 1,5% free lactose ΝΟΥΝΟΥ',
    'Ανα:': '100ml.',
    'Ενέργεια (kcal)': 49,
    'Λιπαρά (γρ.)': 1.5,
    'Κορεσμένα (γρ.)': 0.9,
    'Υδατάνθρακες (γρ.)': 5.1,
    'Σάκχαρα (γρ.)': 5.1,
    'Εδώδιμες ίνες  (γρ.)': 0,
    'Πρωτεϊνη (γρ.)': 3.4,
    'Αλάτι (γρ.)': 0.1,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Γιαούρτι 5% TOTAL (ΦΑΓΕ)',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 96,
    'Λιπαρά (γρ.)': 5,
    'Κορεσμένα (γρ.)': 3.6,
    'Υδατάνθρακες (γρ.)': 3.8,
    'Σάκχαρα (γρ.)': 3.8,
    'Εδώδιμες ίνες  (γρ.)': 0,
    'Πρωτεϊνη (γρ.)': 9,
    'Αλάτι (γρ.)': 0.1,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Γιαούρτι 2% TOTAL (ΦΑΓΕ)',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 73,
    'Λιπαρά (γρ.)': 2,
    'Κορεσμένα (γρ.)': 1.3,
    'Υδατάνθρακες (γρ.)': 3.8,
    'Σάκχαρα (γρ.)': 3.8,
    'Εδώδιμες ίνες  (γρ.)': 0,
    'Πρωτεϊνη (γρ.)': 9.9,
    'Αλάτι (γρ.)': 0.1,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Γιαούρτι 0% TOTAL (ΦΑΓΕ)',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 57,
    'Λιπαρά (γρ.)': 0,
    'Κορεσμένα (γρ.)': 0,
    'Υδατάνθρακες (γρ.)': 4,
    'Σάκχαρα (γρ.)': 4,
    'Εδώδιμες ίνες  (γρ.)': 0,
    'Πρωτεϊνη (γρ.)': 10.3,
    'Αλάτι (γρ.)': 0.1,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Γιαούρτι Στραγγιστό 10% ΔΕΛΤΑ',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 132,
    'Λιπαρά (γρ.)': 10,
    'Κορεσμένα (γρ.)': 7,
    'Υδατάνθρακες (γρ.)': 4,
    'Σάκχαρα (γρ.)': 4,
    'Εδώδιμες ίνες  (γρ.)': 0,
    'Πρωτεϊνη (γρ.)': 6.6,
    'Αλάτι (γρ.)': 0.13,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Γιαούρτι Στραγγιστό 2% ΔΕΛΤΑ',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 74,
    'Λιπαρά (γρ.)': 2,
    'Κορεσμένα (γρ.)': 1.4,
    'Υδατάνθρακες (γρ.)': 4.4,
    'Σάκχαρα (γρ.)': 4.4,
    'Εδώδιμες ίνες  (γρ.)': 0,
    'Πρωτεϊνη (γρ.)': 9.5,
    'Αλάτι (γρ.)': 0.1,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Γιαούρτι 10% ΔΕΛΤΑ Complet',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 128,
    'Λιπαρά (γρ.)': 10,
    'Κορεσμένα (γρ.)': 6.5,
    'Υδατάνθρακες (γρ.)': 3.7,
    'Σάκχαρα (γρ.)': 3.7,
    'Εδώδιμες ίνες  (γρ.)': 0,
    'Πρωτεϊνη (γρ.)': 5.2,
    'Αλάτι (γρ.)': 0.11,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Γιαούρτι 2% ΔΕΛΤΑ Complet',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 68,
    'Λιπαρά (γρ.)': 2,
    'Κορεσμένα (γρ.)': 1.3,
    'Υδατάνθρακες (γρ.)': 5.3,
    'Σάκχαρα (γρ.)': 4.1,
    'Εδώδιμες ίνες  (γρ.)': 0,
    'Πρωτεϊνη (γρ.)': 6.5,
    'Αλάτι (γρ.)': 0.15,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Γιαούρτι 0% ΔΕΛΤΑ Protein Complet',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 59,
    'Λιπαρά (γρ.)': 0.1,
    'Κορεσμένα (γρ.)': 0,
    'Υδατάνθρακες (γρ.)': 3.8,
    'Σάκχαρα (γρ.)': 4.2,
    'Εδώδιμες ίνες  (γρ.)': 0,
    'Πρωτεϊνη (γρ.)': 10,
    'Αλάτι (γρ.)': 0.1,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Γιαούρτι 2% ΔΕΛΤΑ Free lactose Complet',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 66,
    'Λιπαρά (γρ.)': 2,
    'Κορεσμένα (γρ.)': 1.2,
    'Υδατάνθρακες (γρ.)': 4.2,
    'Σάκχαρα (γρ.)': 4.2,
    'Εδώδιμες ίνες  (γρ.)': 0,
    'Πρωτεϊνη (γρ.)': 7.2,
    'Αλάτι (γρ.)': 0.11,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Φυτικό επιδόρπιο Αμύγδαλο plus protein ΔΕΛΤΑ',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 57,
    'Λιπαρά (γρ.)': 2.2,
    'Κορεσμένα (γρ.)': 0.2,
    'Υδατάνθρακες (γρ.)': 4,
    'Σάκχαρα (γρ.)': 0.2,
    'Εδώδιμες ίνες  (γρ.)': 0.8,
    'Πρωτεϊνη (γρ.)': 5,
    'Αλάτι (γρ.)': 0.11,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: 'Φυτικό επιδόρπιο Αμύγδαλο plus protein mango ΔΕΛΤΑ',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': 58,
    'Λιπαρά (γρ.)': 1.9,
    'Κορεσμένα (γρ.)': 0.2,
    'Υδατάνθρακες (γρ.)': 5.5,
    'Σάκχαρα (γρ.)': 0.7,
    'Εδώδιμες ίνες  (γρ.)': 0.9,
    'Πρωτεϊνη (γρ.)': 4.3,
    'Αλάτι (γρ.)': 0.11,
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: '',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': '',
    'Λιπαρά (γρ.)': '',
    'Κορεσμένα (γρ.)': '',
    'Υδατάνθρακες (γρ.)': '',
    'Σάκχαρα (γρ.)': '',
    'Εδώδιμες ίνες  (γρ.)': '',
    'Πρωτεϊνη (γρ.)': '',
    'Αλάτι (γρ.)': '',
    'Κωδικός -Κατηγοριας': 4
  },
  {
    name: '',
    'Ανα:': '100γρ.',
    'Ενέργεια (kcal)': '',
    'Λιπαρά (γρ.)': '',
    'Κορεσμένα (γρ.)': '',
    'Υδατάνθρακες (γρ.)': '',
    'Σάκχαρα (γρ.)': '',
    'Εδώδιμες ίνες  (γρ.)': '',
    'Πρωτεϊνη (γρ.)': '',
    'Αλάτι (γρ.)': '',
    'Κωδικός -Κατηγοριας': 4
  }
];
